export interface AudioSettings {
  musicEnabled: boolean;
  musicVolume: number;
  currentTrack: number;
}

// COMMENTED OUT: Audio functionality disabled
/*
class AudioService {
  private static instance: AudioService;
  private audio: HTMLAudioElement | null = null;
  private tracks = [
    '/music/Design Dreams.mp3',
    '/music/Neon Pulse.mp3',
    '/music/Study Groove.mp3'
  ];
  private currentTrackIndex = 0;
  private settings: AudioSettings = {
    musicEnabled: true,
    musicVolume: 0.5,
    currentTrack: 0
  };

  private constructor() {
    this.initializeAudio();
  }

  static getInstance(): AudioService {
    if (!AudioService.instance) {
      AudioService.instance = new AudioService();
    }
    return AudioService.instance;
  }

  private initializeAudio() {
    this.audio = new Audio();
    this.audio.volume = this.settings.musicVolume;
    this.audio.loop = false;
    
    this.audio.addEventListener('ended', () => {
      this.playNextTrack();
    });
  }

  play() {
    if (!this.audio || !this.settings.musicEnabled) return;
    
    if (!this.audio.src) {
      this.audio.src = this.tracks[this.currentTrackIndex];
    }
    
    this.audio.play().catch(error => {
      console.warn('Failed to play audio:', error);
    });
  }

  pause() {
    if (!this.audio) return;
    this.audio.pause();
  }

  stop() {
    if (!this.audio) return;
    this.audio.pause();
    this.audio.currentTime = 0;
  }

  private playNextTrack() {
    if (!this.settings.musicEnabled) return;
    
    this.currentTrackIndex = (this.currentTrackIndex + 1) % this.tracks.length;
    this.settings.currentTrack = this.currentTrackIndex;
    
    if (this.audio) {
      this.audio.src = this.tracks[this.currentTrackIndex];
      this.play();
    }
  }

  skipToNext() {
    this.currentTrackIndex = (this.currentTrackIndex + 1) % this.tracks.length;
    this.settings.currentTrack = this.currentTrackIndex;
    
    if (this.audio) {
      this.audio.src = this.tracks[this.currentTrackIndex];
      if (this.settings.musicEnabled) {
        this.play();
      }
    }
  }

  skipToPrevious() {
    this.currentTrackIndex = (this.currentTrackIndex - 1 + this.tracks.length) % this.tracks.length;
    this.settings.currentTrack = this.currentTrackIndex;
    
    if (this.audio) {
      this.audio.src = this.tracks[this.currentTrackIndex];
      if (this.settings.musicEnabled) {
        this.play();
      }
    }
  }

  setEnabled(enabled: boolean) {
    this.settings.musicEnabled = enabled;
    
    if (enabled) {
      this.play();
    } else {
      this.pause();
    }
  }

  setVolume(volume: number) {
    this.settings.musicVolume = Math.max(0, Math.min(1, volume));
    
    if (this.audio) {
      this.audio.volume = this.settings.musicVolume;
    }
  }

  getSettings(): AudioSettings {
    return { ...this.settings };
  }

  applySettings(settings: Partial<AudioSettings>) {
    if (settings.musicEnabled !== undefined) {
      this.setEnabled(settings.musicEnabled);
    }
    
    if (settings.musicVolume !== undefined) {
      this.setVolume(settings.musicVolume);
    }
    
    if (settings.currentTrack !== undefined && this.audio) {
      this.currentTrackIndex = settings.currentTrack % this.tracks.length;
      this.settings.currentTrack = this.currentTrackIndex;
      this.audio.src = this.tracks[this.currentTrackIndex];
      
      if (this.settings.musicEnabled) {
        this.play();
      }
    }
  }

  getCurrentTrackName(): string {
    const trackPath = this.tracks[this.currentTrackIndex];
    const filename = trackPath.split('/').pop() || '';
    return filename.replace('.mp3', '');
  }

  isPlaying(): boolean {
    return this.audio ? !this.audio.paused && this.settings.musicEnabled : false;
  }

  togglePlayPause() {
    if (!this.settings.musicEnabled) return;
    
    if (this.isPlaying()) {
      this.pause();
    } else {
      this.play();
    }
  }
}

export const audioService = AudioService.getInstance();
*/

// Mock AudioService with no-op methods
class MockAudioService {
  private settings: AudioSettings = {
    musicEnabled: false,
    musicVolume: 0.5,
    currentTrack: 0
  };

  play() { /* no-op */ }
  pause() { /* no-op */ }
  stop() { /* no-op */ }
  skipToNext() { /* no-op */ }
  skipToPrevious() { /* no-op */ }
  setEnabled(enabled: boolean) { this.settings.musicEnabled = enabled; }
  setVolume(volume: number) { this.settings.musicVolume = volume; }
  getSettings(): AudioSettings { return { ...this.settings }; }
  applySettings(settings: Partial<AudioSettings>) { 
    Object.assign(this.settings, settings);
  }
  getCurrentTrackName(): string { return 'No Track'; }
  isPlaying(): boolean { return false; }
  togglePlayPause() { /* no-op */ }
}

export const audioService = new MockAudioService();